import { Suspense } from 'react';
import logo from './logo.svg';
// import Routes from './Routes';
import Routes from './routes';
import { BrowserRouter as Router } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>} maxDuration={5000}>
        <Router>
          <Routes />
        </Router>
      </Suspense>
    </div>
  );
}

export default App;
